module.exports = __webpack_public_path__ + "static/media/checklist-white.454543d1.svg";